module.exports = __webpack_public_path__ + "static/media/movement-graphic.9eb01dc1.svg";